'use client';

import { ReactNode, useEffect } from 'react';
import useTralentStore from '@/stores';
import GtmEventTracking, { GtmEventTrackingProps } from '@/lib/_components/GtmEventTracking';

export interface RootWrapperProps {
	children: ReactNode;
	gtmEventTrackingProps?: GtmEventTrackingProps;
}

export default function RootWrapper({ children, gtmEventTrackingProps }: RootWrapperProps) {
	const { setIsBalanceHidden } = useTralentStore();

	useEffect(() => {
		if (localStorage.getItem('isBalanceHidden')) {
			setIsBalanceHidden(true);
		}
	}, [setIsBalanceHidden]);

	return (
		<>
			{gtmEventTrackingProps && <GtmEventTracking {...gtmEventTrackingProps} />}
			{children}
		</>
	);
}
